import React from 'react'
import { StoredIndividualization } from '../../../types/Individualization'
import { useTranslation } from 'react-i18next'
import { AxiosResponse } from 'axios'
import Button from '../../../components/Button'
import Text from '../../../components/Text'
import { useDeleteData } from '../../../hooks/useDeleteData'
import { htmlToText } from '../../../helpers/htmlToText'
import { ApiRoutes } from '../../../services/ApiService'
import { closeModal } from '../../../services/ModalService'
import { showToast } from '../../../services/ToastService'

type DeleteIndividualizationModalProps = {
    individualization: StoredIndividualization
    onSubmit: () => void
}

const DeleteIndividualizationModal: React.FC<
    DeleteIndividualizationModalProps
> = ({ individualization, onSubmit }) => {
    const { t } = useTranslation(['individualization'])
    const { submit } = useDeleteData(
        ApiRoutes.INDIVIDUALIZATIONS,
        individualization.id
    )

    const handleSubmit = () => {
        submit().then((res: AxiosResponse) => {
            if (res.status === 204) {
                closeModal()
                showToast(t('overview.delete_modal.success'))
            } else {
                showToast(t('overview.delete_modal.error'), 'error')
            }
            onSubmit()
        })
    }

    return (
        <div
            className={
                'zr-d-flex zr-items-center zr-justify-between zr-flex-column'
            }
        >
            <Text>
                {t('overview.delete_modal.sub_heading', {
                    article_name: htmlToText(
                        individualization?.article?.cName ??
                            individualization?.kArtikel
                    ),
                })}
            </Text>
            <Button
                hierarchy={'primary'}
                text={t('overview.delete_modal.action')}
                fn={() => handleSubmit()}
                classes={'zr-w-100 zr-mx-4 zr-my-2'}
            />
            <Button
                hierarchy={'secondary'}
                text={t('overview.delete_modal.abort')}
                fn={() => closeModal()}
                classes={'zr-w-100 zr-mx-4 zr-my-2'}
            />
        </div>
    )
}

export default DeleteIndividualizationModal
